import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { Button, GlassCard } from 'components';
import { contractsUtils } from 'api/services/contracts';
import { CONTRACT_STATUS } from 'pages/Contracts/constants';
import './ContractCard.scss';

const { ACTIVE, OPEN, IN_PROGRESS, COMPLETED } = CONTRACT_STATUS;

const ContractCard = ({ contract, onViewDetails }) => {
  const navigate = useNavigate();

  const handleSubmitProposal = (e) => {
    e.stopPropagation();
    navigate(`${contract.public_id}/submit-proposal`);
  };

  const getActionButton = () => {
    switch (contract.status) {
      case ACTIVE:
      case OPEN:
        return (
          <Button className='btn-action-primary' onClick={handleSubmitProposal}>
            Proposal
          </Button>
        );
      case IN_PROGRESS:
        return (
          <Button className='btn-action-status in-progress' disabled>
            In Progress
          </Button>
        );
      case COMPLETED:
        return (
          <Button className='btn-action-status completed' disabled>
            Review
          </Button>
        );
      default:
        return (
          <Button className='btn-action-primary' onClick={handleSubmitProposal}>
            Proposal
          </Button>
        );
    }
  };

  //TODO :-  Hardcoded stats for demo if missing
  const views = contract.views || 0;
  const bids = contract.bids || 0;

  return (
    <GlassCard className='contract-card-dashboard'>
      <div className='details-column'>
        <h3 className='contract-title'>{contract.title}</h3>

        <div className='contract-company'>{contract.business_name}</div>

        <div className='meta-row'>
          <span className='meta-amount'>
            $
            {contractsUtils
              .formatCurrency(contract.amount_usd)
              .replace('$', '')}
          </span>
          <span className='meta-item'>{contract.payment_type}</span>
          {contract.expected_duration_days && (
            <span className='meta-item'>
              {contract.expected_duration_days} days
            </span>
          )}
          <span className='meta-item'>{contract.expertise_level}</span>
        </div>

        <div className='footer-row'>
          <div className='stats-wrapper'>
            {views ? (
              <div className='stat-item '>
                <strong>{views}</strong> views
              </div>
            ) : null}
            {bids ? (
              <div className='stat-item'>
                <strong>{bids}</strong> bids
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className='actions-column'>
        <Button
          variant='outline'
          className='btn-details'
          onClick={(e) => {
            e.stopPropagation();
            onViewDetails(contract.public_id);
          }}
        >
          Details
        </Button>
        {getActionButton()}
      </div>
    </GlassCard>
  );
};

ContractCard.propTypes = {
  contract: PropTypes.object.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

export default ContractCard;
